const React = require('react');
const {FormFooter} = require('../../../../FormHandlers');

const {replaceLocation} = require("../../../../../../router");
const {getAdminLink} = require("../../../../../../utils/adminLinkCtor");
const {LINK_ADMIN_RETAILERS} = require("../../../../../../constants/links");


module.exports = ({submitBtnProps = {}, nextStepBtnProps = {}}) => (
  <div className="mt28 mb20">
    <FormFooter
      submitBtnData={{
        text: 'Save',
        ...submitBtnProps
      }}
      additionalBtnsList={[
        {text: 'Next', ...nextStepBtnProps},
        {text: 'Close', onClick: () => replaceLocation({path: getAdminLink(LINK_ADMIN_RETAILERS)})},
      ]}
    />
  </div>
)
